import { AuthService } from "@framework/services";

export function JwtOptionsFactory(authService: AuthService) {
    return {
        // Resolve per-request so Cognito Bearer is not stuck on a stale GS_TOKEN from app bootstrap.
        tokenGetter: () => {
            const gsToken = authService.getGsToken();
            return gsToken ? gsToken : authService.cognito.getIdToken();
        },
        authScheme: () => (authService.getGsToken() ? 'GSeeker ' : 'Bearer '),
        allowedDomains: [],
        disallowedRoutes: ['/index/activity-feed', /\/app\/[^\/]+\/settings\//i, /\/companies\/[^\/]+\/setting\/media\//i]
    };
}